import React, { useMemo, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import QueryString from 'query-string';
import clsx from 'clsx';

const { app, headoffice, helpers, UI } = Mobi2Go;

const CLASSNAME = 'm2g-language-picker';

const ITEM_CLASS_SUFFIX = '-item';

const getLanguageUrl = language => {
    const { protocol, host, pathname, search, hash } = window.location;
    const query_string = QueryString.stringify({
        ...QueryString.parse(search),
        language,
    });

    return `${protocol}//${host}${pathname}?${query_string}${hash}`;
};

const LanguagePicker = ({ className, hideCurrent }) => {
    const [t, i18n] = useTranslation('order.footer');

    const showLanguagePickerSpinner = useCallback(
        language => () => {
            if (app.isMobileUI()) {
                UI.full_screen_alert.show({
                    icon: 'spinner',
                    text: t('switching_language_alert_text'),
                    subtext: t('switching_language_alert_subtext', {
                        endonym: t(`endonyms:${language}`),
                    }),
                    primary_button: null,
                });
            }
        },
        [t]
    );

    const filteredLanguages = useMemo(
        () =>
            headoffice.languages.filter(
                ({ tag }) => !hideCurrent || tag !== i18n.language
            ),
        [hideCurrent, i18n.language]
    );

    return (
        headoffice.languages.length > 1 && (
            <div className={clsx(CLASSNAME, className)}>
                {filteredLanguages.map((language, index) => {
                    const is_selected = app.language === language.tag;
                    const itemClassName = clsx(
                        CLASSNAME + ITEM_CLASS_SUFFIX,
                        className && className + ITEM_CLASS_SUFFIX
                    );

                    return (
                        <Fragment key={language.tag}>
                            {is_selected ? (
                                <span
                                    className={itemClassName}
                                    data-is-selected={is_selected}
                                >
                                    {helpers.capitalise(language.endonym)}
                                </span>
                            ) : (
                                <a
                                    key={language.tag}
                                    className={itemClassName}
                                    href={getLanguageUrl(language.tag)}
                                    data-is-selected={is_selected}
                                    onClick={showLanguagePickerSpinner(
                                        language.tag
                                    )}
                                >
                                    {helpers.capitalise(language.endonym)}
                                </a>
                            )}
                            {index !== headoffice.languages.length - 1 ? (
                                <span> </span>
                            ) : null}
                        </Fragment>
                    );
                })}
            </div>
        )
    );
};

LanguagePicker.propTypes = {
    className: PropTypes.string,
    hideCurrent: PropTypes.bool,
};

LanguagePicker.defaultProps = {
    className: null,
    hideCurrent: false,
};

export default LanguagePicker;
